import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PlantanalysisShowcaseComponent } from './plantanalysis-showcase/plantanalysis-showcase.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { PlantanalysistestComponent } from './plantanalysis-showcase/plantanalysistest/plantanalysistest.component';
import { PlantanalysistestresultComponent } from './plantanalysis-showcase/plantanalysistestresult/plantanalysistestresult.component';
import { HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { GraphQLModule } from './graphql.module';

@NgModule({
  declarations: [
    AppComponent,
    PlantanalysisShowcaseComponent,
    PlantanalysistestComponent,
    PlantanalysistestresultComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    GraphQLModule
  ],
  providers: [
    provideHttpClient(withFetch())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
